import { inject, Injectable } from '@angular/core';
import { ApiCallingV2Service, API_CONFIG } from '@zayan-erp/shared';
import { Observable } from 'rxjs';
import { Note } from '@zayan-erp/sales';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class NotesService {
  #http = inject(ApiCallingV2Service);
  #apiConfig = inject(API_CONFIG);
  baseUrl = this.#apiConfig.baseUrlV2;

  form = new FormGroup({
    noteTypeId: new FormControl<string | null>(null, [Validators.required]),
    note: new FormControl<string | null>(null, [Validators.required]),
    s3DocumentId: new FormControl<string | null>(null)
  });

  readNotes(lotId: string): Observable<Note[]> {
    return this.#http.getData<Note[]>(`${this.baseUrl}/lots/${lotId}/notes`, { showLoader: true, showMessage: false });
  }

  createNote(lotId: string, note: any): Observable<Note> {
    return this.#http.postData<Note>(
      `${this.baseUrl}/lots/${lotId}/notes`,
      { showLoader: true, buttonId: 'save-notes', showMessage: true },
      note
    );
  }

  getNoteById(lotId: string, noteId: string): Observable<Note> {
    return this.#http.getData<Note>(`${this.baseUrl}/lots/${lotId}/notes/${noteId}`, {
      showLoader: true,
      showMessage: false
    });
  }

  updateNote(lotId: string, noteId: string, note: any): Observable<Note> {
    return this.#http.putData<Note>(`${this.baseUrl}/lots/${lotId}/notes/${noteId}`, note, {
      showLoader: true,
      buttonId: 'save-notes',
      showMessage: true
    });
  }

  deleteNote(lotId: string, noteId: string): Observable<void> {
    return this.#http.deleteData<void>(`${this.baseUrl}/lots/${lotId}/notes/${noteId}`, {
      showLoader: true,
      showMessage: false
    });
  }
}
